import { Box } from '@mui/material';

import { InfoDialog, Button } from '@occc-app/design-system';

export type ChangeCpgModalProps = {
  show: boolean;
  fromCpgName: string;
  toCpgName: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ChangeCpgModal = ({
  show,
  fromCpgName,
  toCpgName,
  onCancel,
  onConfirm,
}: ChangeCpgModalProps) => {
  return (
    <InfoDialog
      open={show}
      maxWidth='sm'
      hideCloseButton
      onClose={onCancel}
      fullWidth
      disableRestoreFocus
    >
      <Box sx={{ p: 1 }}>
        <Box sx={{ mb: 2 }}>
          Attempting to change the CPG from {fromCpgName} to {toCpgName} will update the submission
          destination for all stores in this group.
        </Box>
        <Box sx={{ mb: 2 }}>Please confirm this change is correct before proceeding.</Box>
        <Box>Note: You may also need to update the Submitter ID when switching CPGs.</Box>
        <Box display='flex' justifyContent='flex-end' gap={1} mt={3}>
          <Button variant='text' onClick={onCancel}>
            CANCEL
          </Button>
          <Button variant='contained' onClick={onConfirm}>
            I Understand
          </Button>
        </Box>
      </Box>
    </InfoDialog>
  );
};
